'use client';
import type { Highlight } from '@/modules/CrossSell/interface/Highlight';
import Image from 'next/image';
import Link from 'next/link';
import { Flex, Skeleton } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { PATHS } from '@/config/paths';
import { WidgetContainer } from '@/components/modules/Widget/Container';
import { useGetHighlights } from '@/modules/CrossSell/http/client/useGetHighlights';
import '@eqi-investimentos/slider/css';

export const Highlights = () => {
  const t = useT();

  const { data: highlights = [], isFetching } = useGetHighlights();

  return (
    <WidgetContainer
      title={t('widgets.HighlightsWidget.title')}
      containerId="highlights-carrousel"
      sliderProps={{
        autoplay: true,
        delay: 4000,
        slidesPerView: 2,
      }}
      containerSxProps={{
        '.swiper-slide:not(.native-swiper)': {
          w: 'fit-content !important',
        },
      }}
    >
      {isFetching
        ? Array.from({ length: 3 }).map((_, idx) => (
            <Skeleton
              key={idx}
              w="55.25rem"
              h="20.5rem"
              borderRadius="0.5188rem"
            />
          ))
        : highlights.map(({ id, thumb, title, ...rest }) => (
            <Flex
              key={id}
              as={Link}
              href={
                mountHighlightItemLink({ id, thumb, title, ...rest }) || '#'
              }
              pos="relative"
              w="55.25rem"
              h="20.5rem"
              borderRadius="lg"
            >
              <Flex pos="relative" w="55.25rem" h="20.5rem" borderRadius="lg">
                <Image
                  alt={title}
                  src={thumb}
                  fill
                  style={{ objectFit: 'cover', borderRadius: '0.5rem' }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = '/assets/eqi-placeholder.png';
                  }}
                />
              </Flex>
            </Flex>
          ))}
    </WidgetContainer>
  );
};

const mountHighlightItemLink = ({
  content,
  destination_link,
  type,
  ...props
}: Highlight) => {
  if (destination_link) {
    return destination_link;
  }

  if (['author', 'program'].includes(type)) {
    const highlightType = type as 'author' | 'program';
    return `${PATHS.hubs[highlightType]}/${props[highlightType]?.slug}`;
  }

  return `${PATHS.hubs.content}/${content?.slug}`;
};
